module.exports = __webpack_public_path__ + "img/识别速度.656e8a1c.png";